import * as React from 'react';
import cx from 'classnames';
import { Switch as UiSwitch } from '@ui/components/ui/switch';

export interface SwitchProps extends Omit<React.LabelHTMLAttributes<HTMLLabelElement>, 'htmlFor' | 'onChange'> {
  value?: boolean;
  disabled?: boolean;
  size?: number;
  text?: string;
  /** Fired when the user toggles (no event object; previous API used a native checkbox — use `value` for state). */
  onChange?: VoidFunction;
}

/** Legacy API (`value`, `text`, checkbox-style `onChange`) implemented on top of `@ui/components/ui/switch`. */
export const Switch = ({
  value = false,
  size = 48,
  className,
  text,
  onChange,
  disabled,
  ...labelProps
}: SwitchProps): JSX.Element => {
  const controlId = React.useId();
  const uiSize: 'sm' | 'default' = typeof size === 'number' && size <= 34 ? 'sm' : 'default';
  const handleCheckedChange = () => {
    onChange?.();
  };
  return (
    <label
      {...labelProps}
      htmlFor={controlId}
      className={cx(
        'inline-flex items-center gap-2 text-start',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        className,
      )}
    >
      <UiSwitch
        id={controlId}
        checked={value}
        disabled={disabled}
        size={uiSize}
        onCheckedChange={handleCheckedChange}
      />
      {/* The label greys out with the control, so a disabled switch reads as unavailable as a whole
          rather than as a live label beside a faded toggle. */}
      {text ? (
        <span className={cx('text-sm', disabled ? 'text-muted-foreground opacity-50' : 'text-foreground')}>{text}</span>
      ) : null}
    </label>
  );
};
